/**
 * Parent → branch relationships between traditions.
 *
 * Kept intentionally conservative — only lineage relationships that are
 * historically uncontroversial. We do NOT declare Gnosticism a "branch" of
 * Christianity here (esoteric currents are cross-fertilised in both
 * directions), but we DO surface streams that clearly emerged from a parent
 * tradition and remain identifiable as such.
 *
 * `TRADITION_PARENTS[slug]` — the single parent tradition slug for `slug`, if any.
 * `TRADITION_BRANCHES[slug]` — the derived list of child slugs for `slug`.
 */
import { TRADITION_BY_SLUG } from "./traditions";

export const TRADITION_PARENTS = {
  vedanta: "hinduism",
  tantra: "hinduism",
  "vedic-astrology": "hinduism",
  "tibetan-buddhism": "buddhism",
  kabbalah: "judaism",
  sufism: "islam",
  "quantum-physics": "modern-physics",
  alchemy: "hermeticism",
};

export const TRADITION_BRANCHES = (() => {
  const out = {};
  for (const [child, parent] of Object.entries(TRADITION_PARENTS)) {
    if (!out[parent]) out[parent] = [];
    out[parent].push(child);
  }
  return out;
})();

/** Returns the parent tradition object (from TRADITIONS), or null. */
export function parentOf(slug) {
  const parentSlug = TRADITION_PARENTS[slug];
  if (!parentSlug) return null;
  return TRADITION_BY_SLUG[parentSlug] || null;
}

/** Returns an array of branch tradition objects, or []. */
export function branchesOf(slug) {
  const children = TRADITION_BRANCHES[slug] || [];
  return children
    .map((s) => TRADITION_BY_SLUG[s])
    .filter(Boolean);
}
